import { SVGProps, Ref, forwardRef } from 'react';

export const TrashFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 5v1.8h2V16c0 6 2 8 8 8h2c6 0 8-2 8-8V6.8h2V5h-5.464C16.802 2.168 15.124 0 12 0S7.198 2.168 6.464 5zm7.335 0h7.33c-.236-.753-.545-1.389-.92-1.884C14.126 2.302 13.291 1.8 12 1.8s-2.127.502-2.744 1.316C8.88 3.61 8.57 4.247 8.336 5m2.065 5v9H8.6v-9zm5 0v9h-1.8v-9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrashFilledSize24Glyph.displayName = 'TrashFilledSize24Glyph';
